export const LISTING_RECORD_ID = 'category'
